






























































































import { Route } from 'vue-router'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import InviteWorkerModal, {
  Props as ModalProps
} from '../components/manageTeam/InviteWorkerModal.vue'
import { User, Patient, PrivateWorker } from '../types/user'
import { EventEmitter } from 'events'

type CheckedExcludeList = {
  [id: number]: boolean
}

enum EventTypes {
  CONFIRM
}
enum AlertConfirmResults {
  OK,
  CANCEL
}

const ALERT_MESSAGE_EXCLUDE_MYSELF =
  '自分自身を削除すると以降の操作ができなくなります。実行しますか？'
const ALERT_MESSAGE_REMOVE_PERMISSION_MYSELF =
  '自分自身の未許可にすると以降の操作ができなくなります。実行しますか？'

@Component({
  components: {
    ControlTable: () => import('../components/ControlTable.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue'),
    AlertModal: () => import('@/components/common/modals/AlertModal.vue'),
    InviteWorkerModal: InviteWorkerModal
  }
})
export default class ManageTeamDetail extends Vue {
  @Prop(Number) readonly patientId!: number

  $store!: ExStore

  modalShow = false
  modalProps: ModalProps = {
    patient: undefined
  }

  pending = true
  pendingExcludeMember = false
  pendingSwitchIsAdmin = false
  checkedExcludeList: CheckedExcludeList = {}

  isShowAlertModal = false
  alertModalMessage = ''
  events = new EventEmitter()

  get patient() {
    return this.$store.getters['patient/patients'][this.patientId]
  }

  get teamMembers() {
    return this.$store.getters['team/teamMembers']
  }

  get memberCount() {
    return this.teamMembers.length
  }

  get workerInfo() {
    return this.$store.getters['user/workerInfo'] as PrivateWorker
  }

  get isAdmin() {
    if (!this.workerInfo) {
      return false
    }
    return this.workerInfo.watching.some(({ patient, isAdmin }) => {
      return this.patientId === patient && isAdmin
    })
  }

  getFullName(user: User): string {
    return user.lastName + user.firstName
  }

  async showAlertModal(message: string) {
    this.isShowAlertModal = true
    this.alertModalMessage = message
    const resust = await new Promise<AlertConfirmResults>(resolve =>
      this.events.once(EventTypes.CONFIRM, resolve)
    )
    this.isShowAlertModal = false
    this.alertModalMessage = ''

    return resust
  }

  handleAlertOk() {
    this.events.emit(EventTypes.CONFIRM, AlertConfirmResults.OK)
  }

  handleAlertCancel() {
    this.events.emit(EventTypes.CONFIRM, AlertConfirmResults.CANCEL)
  }

  handleClickInviteButton(patient: Patient) {
    this.modalProps.patient = patient
    this.modalShow = !this.modalShow
  }

  async handleClickExcludeBatchMember() {
    if (this.pendingExcludeMember) {
      return
    }
    try {
      this.pendingExcludeMember = true

      const checkedExcludeList = this.checkedExcludeList
      const targets = Object.keys(checkedExcludeList)
        .map(Number)
        .filter(id => checkedExcludeList[id])

      if (targets.length === 0) {
        return
      }

      if (targets.indexOf(this.workerInfo.id) > -1) {
        if (
          (await this.showAlertModal(ALERT_MESSAGE_EXCLUDE_MYSELF)) ===
          AlertConfirmResults.CANCEL
        ) {
          return
        }
      }

      const patientId = this.patientId

      await Promise.all(
        targets.map(workerId =>
          this.$store.dispatch('team/deleteTeamMember', {
            patientId,
            workerId
          })
        )
      )
      if (targets.indexOf(this.workerInfo.id) > -1) {
        this.$router.push({ name: 'Home' })
      }
    } catch (error) {
      //
    } finally {
      this.pendingExcludeMember = false
    }
  }

  async handleClickSwitchIsAdmin(workerId: number, isAdmin: boolean) {
    if (this.pendingSwitchIsAdmin) {
      return
    }

    try {
      this.pendingSwitchIsAdmin = true
      if (workerId === this.workerInfo.id) {
        if (
          (await this.showAlertModal(
            ALERT_MESSAGE_REMOVE_PERMISSION_MYSELF
          )) === AlertConfirmResults.CANCEL
        ) {
          return
        }
      }
      const patientId = this.patientId
      await this.$store.dispatch('team/patchTeamMember', {
        patientId,
        workerId,
        params: { isAdmin }
      })

      if (workerId === this.workerInfo.id) {
        await this.$store.dispatch('user/updateWorkerInfo')
      }
    } catch (error) {
      //
    } finally {
      this.pendingSwitchIsAdmin = false
    }
  }

  async created() {
    const patientId = this.patientId

    this.pending = true
    await Promise.all([
      this.$store.dispatch('user/updateWorkerInfo'),
      this.$store.dispatch('patient/update', { patientId })
    ])
    this.$store.dispatch('team/fetchTeamMembers', { patientId }).then(() => {
      this.pending = false
      this.checkedExcludeList = this.teamMembers.reduce(
        (checkedList, member) => {
          return Object.assign(checkedList, { [member.worker.id]: false })
        },
        {} as CheckedExcludeList
      )
    })
  }
}
